import React from 'react';

export default class BackLink extends React.Component {

  render() {
    return <div className="back_link">
            <a href="/">Početna</a> > <a href="#" onClick={() => this.props.getData()}>ESF projekt</a> > {this.props.article.name}
          </div>
  }
}
